module.exports = __webpack_public_path__ + "static/media/king-country-site-logo.c099003d.svg";